module.exports = __webpack_public_path__ + "static/img/privacypolicy-banner.f03000a.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/FFP/images/privacypolicy-banner.png
// module id = krk7
// module chunks = 0